import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import ReservationModal from "./ReservationModal";
import EditModal from "./EditModal";
import { isMobile } from "react-device-detect";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

export default function Parking4() {
  const [userStatus, setUserStatus] = useState();
  const [placesFromDB, setPlacesFromDB] = useState({});
  const [placesFromDB2, setPlacesFromDB2] = useState({});
  const [placesFromDB3, setPlacesFromDB3] = useState({});
  const [place, setPlace] = useState();
  const [placeData, setPlaceData] = useState();
  const [change, setChange] = useState(false);
  const [changeType, setChangeType] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [parking, setParking] = useState(true);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserStatus(user.displayName);
      }
    });
  }, []);

  // Funkcja do pobierania danych z Firebase
  const getPlaces = async () => {
    const docRef = doc(db, "parking4", "4ZwW85VfvmHVHEfROPbi");
    const response = await getDoc(docRef);

    if (response.exists()) {
      const parking1 = response.data().parking;
      const placesObj = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1A") {
            placesObj[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
            };
          }
        });
      }

      const placesObj2 = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1B") {
            placesObj2[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
            };
          }
        });
      }

      const placesObj3 = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1C") {
            placesObj3[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
            };
          }
        });
      }

      setPlacesFromDB(placesObj);
      setPlacesFromDB2(placesObj2);
      setPlacesFromDB3(placesObj3);
    }
  };

  useEffect(() => {
    getPlaces(); // Pobierz miejsca na początku
  }, [change]);

  const renderPlace1 = (placeId) => {
    const placeData = placesFromDB[placeId];

    const parkingSpace = (
      <div
        onClick={(e) => {
          if (placeData) {
            setChangeType(!changeType);
            setPlaceData(placeData);
            setOpen2(true);
          } else {
            setChangeType(!changeType);
            setParking("1A");
            setPlace(placeId);
            setOpen(true);
          }
        }}
        className={`parking-space-3 ${
          placeData && placeData.type === "Amazon"
            ? "amazon-place-2"
            : placeData && placeData.type === "Slam"
            ? "slam-place-2"
            : ""
        }`}
      >
        <div className="parking-space-3">
          {placeData && <p>{placeData.containerNumber}</p>}
        </div>
      </div>
    );

    return parkingSpace;
  };

  const renderPlace2 = (placeId) => {
    const placeData = placesFromDB2[placeId];

    const parkingSpace = (
      <div
        onClick={(e) => {
          if (placeData) {
            setChangeType(!changeType);
            setPlaceData(placeData);
            setOpen2(true);
          } else {
            setChangeType(!changeType);
            setParking("1B");
            setPlace(placeId);
            setOpen(true);
          }
        }}
        className={`parking-space-3 ${
          placeData && placeData.type === "Amazon"
            ? "amazon-place"
            : placeData && placeData.type === "Slam"
            ? "slam-place"
            : ""
        }`}
      >
        <div className="parking-space-3">
          {placeData && <p>{placeData.containerNumber}</p>}
        </div>
      </div>
    );

    return parkingSpace;
  };

  const btn_1 = document.querySelector(".btn-12");
  const btn_2 = document.querySelector(".btn-22");

  useEffect(() => {
    if (parking && btn_1 && btn_2) {
      btn_1.classList.add("btn-active");
      btn_2.classList.remove("btn-active");
    } else if (!parking && btn_1 && btn_2) {
      btn_2.classList.add("btn-active");
      btn_1.classList.remove("btn-active");
    }
  }, [parking, btn_1, btn_2]);

  const elements = Array.from({ length: 44 }, (_, index) => (
    <div key={index} className="item-2">
      {renderPlace1(index)} <div className="circle-right"></div>
    </div>
  ));

  const elements2 = Array.from({ length: 56 }, (_, index) => (
    <div key={index} className="item">
      {renderPlace2(index)} <div className="circle-right"></div>
    </div>
  ));

  // Sekcje podzielone na 74, 73, i 73 elementy
  const section1 = elements;
  const section2 = elements2;

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossorigin="anonymous"
      ></link>
      <ReservationModal
        setChange={setChange}
        change={change}
        parking={parking}
        open={open}
        setOpen={setOpen}
        changeType={changeType}
        place={place}
        collection={"parking4"}
        documentId={"4ZwW85VfvmHVHEfROPbi"}
      />

      <EditModal
        setChange={setChange}
        change={change}
        open={open2}
        setChangeType={setChangeType}
        changeType={changeType}
        setOpen={setOpen2}
        placeData={placeData}
        collection={"parking4"}
        documentId={"4ZwW85VfvmHVHEfROPbi"}
      />
      <div
        className="content"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div
          className="container"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <div className="fence">
          <div className="entrance-3"><p>MAGAZINE EXIT REAR</p></div>
          <div className="wall-3"></div>
            <div style={{ display: "flex", flexFlow: "row nowrap" }}>
            <div style={{ display: "flex", flexFlow: "column nowrap", position: 'relative' }}>

              <div className="building"><p>BUILDING</p></div>
              <div style={{ display: "flex", flexDirection: "column" }}>
              <h3 style={{ textAlign: "center" }}>PARKING 4A</h3>
              <div className="section-42">{section1}</div>
            </div>
            </div>
              <div style={{ display: "flex", flexDirection: "column", marginLeft: '-14rem' }}>
                <h3 style={{ textAlign: "center"}}>PARKING 4B</h3>
                <div className="section-41">{section2}</div>
              </div>
            </div>
            <div className="access-9"><p>ACCESS</p></div>
            <div className="access-10"><p>ACCESS</p></div>
            <div className="road-5"><p>ROAD</p></div>

          </div>

        </div>
      </div>
    </>
  );
}
